import settings from '/@/core/settings';
import { axFetch } from '/@/store/session/actions';
import type { Zone } from '/@/types/zone';

export const getZonesFromAPI = async ({ lat, lng, type, plantingDate }) => {
    const params = new URLSearchParams();
    if (lat) params.append('lat', lat);
    if (lng) params.append('lng', lng);
    if (type) params.append('zone_type', type);
    if (plantingDate) params.append('planting_date', plantingDate);

    const apiUrl = new URL(`${settings.urls.apiDomain}/core/v1/zones/?${params.toString()}`, window.location.origin);

    const res = await axFetch.get<Zone[]>(apiUrl.toString());
    return res.data;
};
